import React, { memo } from "react";
import { useTheme } from "@emotion/react";

type Props = {
    children?: React.ReactNode,
};

const RadioGroup: React.FC<Props> = ({ children }) => {
    const theme = useTheme();
    const styles = () => ({
        marginTop: theme.forms.paddingVertical,
        '> *': {
            marginBottom: theme.forms.paddingVertical,
        }
    });

    return (
        <div css={styles}>
            {children}
        </div>
    );
};

export default memo(RadioGroup);
